import { Language } from '../../enums/language.enum';
import { findTargetLanguagePath } from './find-target-language-path';

export function translateRawPaths(rawPaths: string[], language: Language): string[] {
	const paths: string[] = [];
	for (const segment of rawPaths) {
		try {
			paths.push(findTargetLanguagePath(segment, language));
		} catch (e) {
			paths.push(segment);
		}
	}

	return paths;
}
